import { render } from "./MicroWishPage.vue?vue&type=template&id=6ec6c97a&scoped=true"
import script from "./MicroWishPage.vue?vue&type=script&lang=js"
export * from "./MicroWishPage.vue?vue&type=script&lang=js"

import "./MicroWishPage.vue?vue&type=style&index=0&id=6ec6c97a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec6c97a"]])

export default __exports__